module.exports = __webpack_public_path__ + "img/43_51.8cd23d7d.png";